
import { ref, computed } from 'vue'

import payload from './payload'

import place from './place'

const state = computed( () => place?.state || ' the state' )

import nationalAverage from './national-average'

const generateNHSNWindow = () => {

 if ( payload.value?.nhsn ) return ` ${ payload.value.nhsn.week_end }`;

 return '';

};

const lookupBEAMPathogen = ( pathogenType, db ) => {
 
  const pattern = new RegExp( pathogenType, 'i' );

  return db.value?.beam?.find( pathogen => pathogen.pathogen.match( pattern ) );

};

const generateBEAMWindow = ( pathogenType, db ) => {

  const pathogen = lookupBEAMPathogen( pathogenType, db );

  if ( pathogen ) {

    const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

    return ` for ${ months[ pathogen.month - 1 ] } ${ pathogen.year }`;

  }

  else {
    
    return '';

  }

};

const lookupNNDSSPathogen = ( pathogenType, db ) => {

  const pattern = new RegExp( pathogenType, 'i' );

  return db.value?.nndss?.find( pathogen => pathogen.pathogen.match( pattern ) );

};

const generateNNDSSWindow = ( pathogenType, db ) => {

  const pathogen = lookupNNDSSPathogen( pathogenType, db );

  if ( pathogen ) {

    const day = ( 1 + ( pathogen.week - 1 ) * 7 );

    const date = new Date( pathogen.year, 0, day );

    return ` for week ${ date.getFullYear() }-${ ( date.getMonth() + 1 ).toString().padStart( 2, 0 ) }-${ date.getDate() }`;

  }

  else {

    return '';

  }

};

const parseUpdatedAt = updatedAt => {

  if ( updatedAt ) {
   
    const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

    const date = new Date( `${ updatedAt } UTC` );

    const now = new Date();

    const threshold = 86400000 * 7;

    return {
      
      date,
      
      message: `Data Updated on ${ months[ date.getMonth() ] } ${ date.getDate() }, ${ date.getFullYear() }`,
      
      alert: now - date < threshold
    
    };

  }

  return null;

};

export default ref ( [ {

  id: 1,

  reference: 4,

  tab: 'respiratory',

  title: 'RSV',

  localValue: computed( () => payload.value?.nhsn?.total_patients_rsv ),

  nationalValue: computed( () => nationalAverage.value?.nhsn?.total_patients_rsv.toFixed( 1 ) ),

  alert: computed( () => payload.value?.nhsn?.total_patients_rsv > nationalAverage.value?.nhsn?.total_patients_rsv ),

  description: 'total state patients hospitalized.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( payload.value?.nhsn?.updated_at ) ),

    description: computed(() => `Total number of ${ state.value } patients hospitalized with confirmed RSV captured for the Wednesday of the reporting week ${ generateNHSNWindow() }.` ),

    source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',

    url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',

    active: false

  }

}, {

  id: 2,

  reference: 4,

  tab: 'respiratory',

  title: 'COVID-19',

  localValue: computed( () => payload.value?.nhsn?.total_patients_covid ),

  nationalValue: computed( () => nationalAverage.value?.nhsn?.total_patients_covid.toFixed( 1 ) ),

  alert: computed( () => payload.value?.nhsn?.total_patients_covid > nationalAverage.value?.nhsn?.total_patients_covid ),

  description: 'total state patients hospitalized.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( payload.value?.nhsn?.updated_at ) ),

    description: computed(() => `Total number of ${ state.value } hospitals that reported data for number of confirmed COVID-19 patients for Wednesday of the reporting week ${ generateNHSNWindow() }.` ),

    source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',

    url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',

    active: false

  }
  
}, {

  id: 3,
  
  reference: 4,

  tab: 'respiratory',

  title: 'influenza',

  localValue: computed( () => payload.value?.nhsn?.total_patients_influenza ),

  nationalValue: computed( () => nationalAverage.value?.nhsn?.total_patients_influenza.toFixed( 1 ) ),

  alert: computed( () => payload.value?.nhsn?.total_patients_influenza > nationalAverage.value?.nhsn?.total_patients_influenza ),

  description: 'total state patients hospitalized.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( payload.value?.nhsn?.updated_at ) ),

    description: computed(() => `Total number of ${ state.value } hospitals that reported data for number of confirmed influenza patients for Wednesday of the reporting week ${ generateNHSNWindow() }.` ),

    source: 'Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).',

    url: 'https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data',

    active: false

  }

}, {

  id: 4,

  reference: 5,

  tab: 'gastrointestinal',

  title: '<i>salmonella</i>',

  localValue: computed( () => lookupBEAMPathogen( 'salmonella', payload )?.number_of_isolates ),

  nationalValue: computed( () => lookupBEAMPathogen( 'salmonella', nationalAverage )?.number_of_isolates.toFixed( 1 ) ),

  alert: computed( () => lookupBEAMPathogen( 'salmonella', payload )?.number_of_isolates > lookupBEAMPathogen( 'salmonella', nationalAverage )?.number_of_isolates ),

  description: 'isolates reported in state residents.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupBEAMPathogen( 'salmonella', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the number of <i>Salmonella</i> isolates reported within ${ state.value }${ generateBEAMWindow( 'salmonella', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',

    url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',

    active: false

  }

}, {

  id: 5,

  reference: 5,

  tab: 'gastrointestinal',

  title: 'stec',

  localValue: computed( () => lookupBEAMPathogen( 'stec', payload )?.number_of_isolates ),

  nationalValue: computed( () => lookupBEAMPathogen( 'stec', nationalAverage )?.number_of_isolates.toFixed( 1 ) ),

  alert: computed( () => lookupBEAMPathogen( 'stec', payload )?.number_of_isolates > lookupBEAMPathogen( 'stec', nationalAverage )?.number_of_isolates ),

  description: 'isolates reported in state residents.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupBEAMPathogen( 'stec', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the number of Shiga toxin-producing <i>Escherichia coli</i> (STEC) isolates reported within ${ state.value }${ generateBEAMWindow( 'stec', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',

    url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',

    active: false

  }

}, {

  id: 6,

  reference: 5,

  tab: 'gastrointestinal',

  title: '<i>shigella</i>',

  localValue: computed( () => lookupBEAMPathogen( 'shigella', payload )?.number_of_isolates ),

  nationalValue: computed( () => lookupBEAMPathogen( 'shigella', nationalAverage )?.number_of_isolates.toFixed( 1 ) ),

  alert: computed( () => lookupBEAMPathogen( 'shigella', payload )?.number_of_isolates > lookupBEAMPathogen( 'shigella', nationalAverage )?.number_of_isolates ),

  description: 'isolates reported in state residents.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupBEAMPathogen( 'shigella', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the number of <i>Shigella</i> isolates reported within ${ state.value }${ generateBEAMWindow( 'shigella', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',

    url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',

    active: false

  }

}, {

  id: 7,

  reference: 5,

  tab: 'gastrointestinal',

  title: '<i>campylobacter</i>',

  localValue: computed( () => lookupBEAMPathogen( 'campylobacter', payload )?.number_of_isolates ),

  nationalValue: computed( () => lookupBEAMPathogen( 'campylobacter', nationalAverage )?.number_of_isolates.toFixed( 1 ) ),

  alert: computed( () => lookupBEAMPathogen( 'campylobacter', payload )?.number_of_isolates > lookupBEAMPathogen( 'campylobacter', nationalAverage )?.number_of_isolates ),

  description: 'isolates reported in state residents.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupBEAMPathogen( 'campylobacter', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the number of <i>Campylobacter</i> isolates reported within ${ state.value }${ generateBEAMWindow( 'campylobacter', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',

    url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',

    active: false

  }

}, {

  id: 8,

  reference: 5,

  tab: 'gastrointestinal',

  title: '<i>vibrio</i>',

  localValue: computed( () => lookupBEAMPathogen( 'vibrio', payload )?.number_of_isolates ),

  nationalValue: computed( () => lookupBEAMPathogen( 'vibrio', nationalAverage )?.number_of_isolates.toFixed( 1 ) ),

  alert: computed( () => lookupBEAMPathogen( 'vibrio', payload )?.number_of_isolates > lookupBEAMPathogen( 'vibrio', nationalAverage )?.number_of_isolates ),

  description: 'isolates reported in state residents.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupBEAMPathogen( 'vibrio', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the number of <i>Vibrio</i> isolates reported within ${ state.value }${ generateBEAMWindow( 'vibrio', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.',

    url: 'https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data',

    active: false

  }

}, {

  id: 9,

  reference: 6,

  tab: 'meningitis',

  title: 'meningococcal diseases',

  localValue: computed( () => lookupNNDSSPathogen( 'meningococcal', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'meningococcal', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'meningococcal', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'meningococcal', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'meningococcal', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Meningococcal diseases cases reported within ${ state.value }${ generateNNDSSWindow( 'meningococcal', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 10,

  reference: 6,

  tab: 'meningitis',

  title: '<i>haemophilus influenzae</i>',

  localValue: computed( () => lookupNNDSSPathogen( 'haemophilus influenzae', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'haemophilus influenzae', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'haemophilus influenzae', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'haemophilus influenzae', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'haemophilus influenzae', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of <i>Haemophilus influenzae</i> (inclusive of all invasive <i>Haemophilus</i> cases) reported within ${ state.value }${ generateNNDSSWindow( 'haemophilus influenzae', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 16,

  reference: 6,

  tab: 'meningitis',

  title: 'listeriosis',

  localValue: computed( () => lookupNNDSSPathogen( 'listeriosis', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'listeriosis', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'listeriosis', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'listeriosis', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'listeriosis', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Listeriosis reported within ${ state.value }${ generateNNDSSWindow( 'listeriosis', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 11,

  reference: 6,

  tab: 'tropical-fever',

  title: 'dengue',

  localValue: computed( () => lookupNNDSSPathogen( 'dengue', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'dengue', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'dengue', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'dengue', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'dengue', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Dengue reported within ${ state.value }${ generateNNDSSWindow( 'dengue', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 12,

  reference: 6,

  tab: 'tropical-fever',

  title: 'malaria',

  localValue: computed( () => lookupNNDSSPathogen( 'malaria', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'malaria', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'malaria', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'malaria', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'malaria', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Malaria reported within ${ state.value }${ generateNNDSSWindow( 'malaria', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 13,

  reference: 6,

  tab: 'bloodstream-infections',

  title: 'stec',

  localValue: computed( () => lookupNNDSSPathogen( 'stec', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'stec', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'stec', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'stec', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'stec', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Shiga toxin-producing <i>Escherichia coli</i> (STEC) reported within ${ state.value }${ generateNNDSSWindow( 'stec', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 14,

  reference: 6,

  tab: 'bloodstream-infections',

  title: 'stss',

  localValue: computed( () => lookupNNDSSPathogen( 'stss', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'stss', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'stss', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'stss', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'stss', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of Streptococcal Toxic Shock Syndrome (STSS) reported within ${ state.value }${ generateNNDSSWindow( 'stss', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

}, {

  id: 15,

  reference: 6,

  tab: 'bloodstream-infections',

  title: '<i>candida auris</i>',

  localValue: computed( () => lookupNNDSSPathogen( 'candida auris', payload )?.cumulative_ytd_current_mmwr_year ),

  nationalValue: computed( () => lookupNNDSSPathogen( 'candida auris', nationalAverage )?.cumulative_ytd_current_mmwr_year.toFixed( 1 ) ),

  alert: computed( () => lookupNNDSSPathogen( 'candida auris', payload )?.cumulative_ytd_current_mmwr_year > lookupNNDSSPathogen( 'candida auris', nationalAverage )?.cumulative_ytd_current_mmwr_year ),

  description: 'cumulative YTD MMWR state-level cases.',

  symbol: false,

  moreInfo: {

    updatedAt: computed( () => parseUpdatedAt( lookupNNDSSPathogen( 'candida auris', payload )?.updated_at ) ),

    description: computed( () => `This data point represents the cumulative year-to-date current MMWR year state-level cases of <i>Candida auris</i> (clinical) reported within ${ state.value }${ generateNNDSSWindow( 'candida auris', payload ) }.` ),

    source: 'Centers for Disease Control and Prevention, NNDSS Weekly Data.',

    url: 'https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data',

    active: false

  }

} ] )
